/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { updateCampaignAnalysisResultTitleRequestSchema } from '../campaign-schema';

export const updateCampaignAnalysisResultTitlePathSchema = z.object({
  campaignId: z.string(),
  runId: z.string(),
});

export const updateCampaignAnalysisResultTitleRequestBodySchema =
  updateCampaignAnalysisResultTitleRequestSchema;

export type UpdateCampaignAnalysisResultTitleInput = {
  path: z.input<typeof updateCampaignAnalysisResultTitlePathSchema>;
  body: z.input<typeof updateCampaignAnalysisResultTitleRequestBodySchema>;
  signal?: AbortSignal;
};

export async function updateCampaignAnalysisResultTitle({
  path,
  body,
  signal,
}: UpdateCampaignAnalysisResultTitleInput): Promise<void> {
  const parsedPath = updateCampaignAnalysisResultTitlePathSchema.parse(path);
  const parsedBody =
    updateCampaignAnalysisResultTitleRequestBodySchema.parse(body);

  await socialApiClient.patch(
    `campaigns/${parsedPath.campaignId}/analyses/${parsedPath.runId}/result/title`,
    {
      signal,
      ...(parsedBody === undefined ? {} : { json: parsedBody }),
    },
  );
}
